<template>
    <div :class="['modal', 'fade', tipomodal]" :id="id" tabindex="-1" :aria-labelledby="'ModalLabel'+id"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="'ModalLabel'+id">{{ titulo }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <slot name="alertas"></slot>
                    <slot name="conteudo"></slot>
                </div>
                <div class="modal-footer">
                    <slot name="rodape"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
export default {
    props: ['id', 'titulo', 'tipomodal'],
    mounted() {
        const modalElement = document.getElementById(this.id);
        if (modalElement) {
            const bsModal = new Modal(modalElement);
            modalElement.addEventListener("shown.bs.modal", () => {
                this.$emit("modal-aberto");
            });
        }
    }
}
</script>